import { BaseComponent } from '../../types';

interface MobileCardProps extends BaseComponent {
  title?: string;
  content?: string;
  showMockup?: boolean;
  showStorefrontMockup?: boolean;
}

export function MobileCard({
  className,
  title,
  content,
  showMockup = false,
  showStorefrontMockup = false,
}: MobileCardProps) {
  return (
    <div
      className={`max-w-[400px] xl:max-w-[480px] ${className || ''}`}
      style={{
        display: 'flex',
        padding: '32px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '24px',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.20)',
        width: '100%',
        margin: '0 auto',
      }}
    >
      <h3
        style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
        }}
      >
        {title}
      </h3>

      <p
        style={{
          color: 'rgba(255, 255, 255, 0.80)',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
        }}
      >
        {content}
      </p>

      {showMockup && (
        <>
          <div
            className="xl:max-w-[440px]"
            style={{
              width: '100%',
              maxWidth: '395px',
              height: '258px',
              position: 'relative',
              borderRadius: '32px',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              background: 'rgba(20, 28, 45, 0.40)',
              backdropFilter: 'blur(15px)',
              boxShadow:
                '0 30px 80px 0 rgba(0, 0, 0, 0.50), 0 0 0 1px rgba(255, 255, 255, 0.02), 0 2px 0 1px rgba(255, 255, 255, 0.06) inset, 0 -2px 0 1px rgba(0, 0, 0, 0.40) inset',
            }}
          >
            {/* Notification glow background */}
            <div
              style={{
                width: 'clamp(45px, 15vw, 84px)',
                height: 'clamp(45px, 15vw, 84px)',
                position: 'absolute',
                right: 'clamp(-15px, -5vw, -30px)',
                top: 'clamp(-20px, -7vw, -37px)',
                borderRadius: 'clamp(15px, 4vw, 26px)',
                opacity: 0.5,
                background:
                  'linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%)',
                filter: 'blur(6px)',
                zIndex: 10,
              }}
            />

            {/* Notification container */}
            <div
              style={{
                display: 'flex',
                width: 'clamp(45px, 15vw, 84px)',
                height: 'clamp(45px, 15vw, 84px)',
                justifyContent: 'center',
                alignItems: 'center',
                aspectRatio: '1/1',
                position: 'absolute',
                right: 'clamp(-15px, -5vw, -30px)',
                top: 'clamp(-20px, -7vw, -37px)',
                borderRadius: 'clamp(15px, 4vw, 24px)',
                border: '1px solid rgba(59, 130, 246, 0.25)',
                background: 'rgba(20, 28, 45, 0.40)',
                boxShadow:
                  '0 12px 40px 0 rgba(59, 130, 246, 0.20), 0 2px 0 1px rgba(255, 255, 255, 0.08) inset, 0 -2px 0 1px rgba(0, 0, 0, 0.30) inset',
                backdropFilter: 'blur(10px)',
                zIndex: 11,
              }}
            >
              <img
                src="/icons/ring.svg"
                alt="Notification"
                width="clamp(12, 3vw, 24)"
                height="clamp(12, 3vw, 24)"
              />

              {/* Notification dot */}
              <div
                style={{
                  width: 'clamp(10px, 3vw, 20px)',
                  height: 'clamp(10px, 3vw, 20px)',
                  position: 'absolute',
                  right: 'clamp(4px, 1.5vw, 9px)',
                  top: 'clamp(4px, 1.5vw, 9px)',
                  borderRadius: 'clamp(5px, 1.5vw, 10px)',
                  border: '2px solid rgba(20, 28, 45, 0.90)',
                  background:
                    'linear-gradient(135deg, rgba(59, 130, 246, 0.60) 0%, rgba(139, 92, 246, 0.60) 100%)',
                  boxShadow:
                    '0 4px 12px 0 rgba(59, 130, 246, 0.40), 0 1px 0 2px rgba(255, 255, 255, 0.20) inset',
                }}
              />
            </div>
            {/* Top blur effect */}
            <div
              style={{
                width: '235.763px',
                height: '80px',
                position: 'absolute',
                left: '79.613px',
                top: '-1px',
                opacity: 0.6,
                background:
                  'linear-gradient(90deg, rgba(59, 130, 246, 0.00) 0%, rgba(59, 130, 246, 0.40) 33.33%, rgba(139, 92, 246, 0.40) 66.67%, rgba(139, 92, 246, 0.00) 100%)',
                filter: 'blur(15px)',
              }}
            />

            {/* Avatar */}
            <div
              style={{
                position: 'absolute',
                top: '40px',
                left: '40px',
                width: '56px',
                height: '56px',
                borderRadius: '18px',
                border: '2px solid rgba(59, 130, 246, 0.30)',
                background:
                  'linear-gradient(135deg, rgba(59, 130, 246, 0.20) 0%, rgba(139, 92, 246, 0.20) 100%)',
                boxShadow:
                  '0 8px 24px 0 rgba(59, 130, 246, 0.20), 0 2px 0 2px rgba(255, 255, 255, 0.10) inset, 0 -2px 0 2px rgba(0, 0, 0, 0.30) inset',
              }}
            />

            {/* Lines */}
            <div
              style={{
                position: 'absolute',
                top: '50px',
                left: '112px',
                width: '175px',
                height: '10px',
                borderRadius: '6px',
                background: 'rgba(255, 255, 255, 0.06)',
                boxShadow:
                  '0 2px 4px 0 rgba(0, 0, 0, 0.30) inset, 0 1px 0 0 rgba(255, 255, 255, 0.03)',
              }}
            />
            <div
              style={{
                position: 'absolute',
                top: '72px',
                left: '112px',
                width: '120px',
                height: '10px',
                borderRadius: '6px',
                background: 'rgba(255, 255, 255, 0.06)',
                boxShadow:
                  '0 2px 4px 0 rgba(0, 0, 0, 0.30) inset, 0 1px 0 0 rgba(255, 255, 255, 0.03)',
              }}
            />

            {/* Progress Bar Container */}
            <div
              style={{
                display: 'flex',
                height: '16px',
                padding: '3px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.06)',
                background: 'rgba(255, 255, 255, 0.04)',
                boxShadow:
                  '0 2px 6px 1px rgba(0, 0, 0, 0.40) inset, 0 1px 0 0 rgba(255, 255, 255, 0.03)',
                position: 'absolute',
                top: '140px',
                left: '40px',
                width: '80%',
                maxWidth: '315px',
              }}
            >
              {/* Progress Bar Fill */}
              <div
                style={{
                  width: '204.09px',
                  flex: '1 0 0',
                  background:
                    'linear-gradient(90deg, rgba(59, 130, 246, 0.80) 0%, rgba(139, 92, 246, 0.80) 100%)',
                  boxShadow: '0 1px 0 0 rgba(255, 255, 255, 0.30) inset',
                  filter: 'drop-shadow(0 0 16px rgba(59, 130, 246, 0.60))',
                  borderRadius: '8px',
                }}
              />
            </div>

            {/* Bottom glow effect */}
            <div
              style={{
                width: '85%',
                maxWidth: '335px',
                height: '54px',
                borderRadius: '18px',
                opacity: 0.6,
                background:
                  'linear-gradient(100deg, rgba(59, 130, 246, 0.30) 0%, rgba(139, 92, 246, 0.30) 100%)',
                filter: 'blur(8px)',
                position: 'absolute',
                bottom: '20px',
                left: '30px',
              }}
            />

            {/* Bottom rectangle */}
            <div
              style={{
                width: '85%',
                maxWidth: '335px',
                height: '54px',
                borderRadius: '18px',
                opacity: 0.6,
                background:
                  'linear-gradient(100deg, rgba(59, 130, 246, 0.30) 0%, rgba(139, 92, 246, 0.30) 100%)',
                position: 'absolute',
                bottom: '20px',
                left: '30px',
              }}
            />
          </div>
        </>
      )}

      {showStorefrontMockup && (
        <div
          className="xl:max-w-[440px]"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            borderRadius: '44px',
            border: '1px solid rgba(255, 255, 255, 0.06)',
            background: 'rgba(255, 255, 255, 0.02)',
            boxShadow:
              '0 18px 50px 0 rgba(0, 0, 0, 0.35), 0 1px 0 1px rgba(255, 255, 255, 0.08) inset',
            backdropFilter: 'blur(12.5px)',
            position: 'relative',
            padding: '16px 24px 24px 24px',
            width: '100%',
            maxWidth: '395px',
            height: '258px',
          }}
        >
          {/* Notification dot in top-right */}
          <div
            style={{
              display: 'flex',
              width: '18px',
              height: '18px',
              flexDirection: 'column',
              alignItems: 'flex-start',
              position: 'absolute',
              right: '11px',
              top: '3px',
              borderRadius: '9px',
              border: '2px solid #0A0E27',
              background: '#3B82F6',
              boxShadow:
                '0 0 22px 0 #3B82F6, 0 0 44px 0 rgba(59, 130, 246, 0.65)',
            }}
          />

          {/* Storefront icon container */}
          <div
            style={{
              display: 'flex',
              width: '90px',
              height: '90px',
              justifyContent: 'center',
              alignItems: 'center',
              aspectRatio: '1/1',
              borderRadius: '26px',
              border: '2px solid rgba(139, 92, 246, 0.28)',
              background:
                'linear-gradient(135deg, rgba(139, 92, 246, 0.14) 0%, rgba(99, 102, 241, 0.09) 100%)',
              boxShadow:
                '0 10px 28px 0 rgba(139, 92, 246, 0.22), 0 1px 0 2px rgba(255, 255, 255, 0.12) inset',
              backdropFilter: 'blur(11px)',
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '90px',
                height: '90px',
                justifyContent: 'center',
                alignItems: 'center',
                aspectRatio: '1/1',
              }}
            >
              <img
                src="/icons/storefront-icon.svg"
                alt="Storefront"
                width="70"
                height="70"
                style={{
                  display: 'flex',
                  width: '56px',
                  paddingBottom: '2px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexShrink: 0,
                }}
              />
            </div>
          </div>

          {/* Two interface cards */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              width: '100%',
              paddingBottom: '19px',
            }}
          >
            {/* First card */}
            <div
              style={{
                display: 'flex',
                padding: '12px',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.04)',
                background: 'rgba(255, 255, 255, 0.02)',
                boxShadow:
                  '0 4px 12px 0 rgba(0, 0, 0, 0.25), 0 1px 0 1px rgba(255, 255, 255, 0.04) inset',
              }}
            >
              {/* Blue icon on the left */}
              <div
                style={{
                  display: 'flex',
                  width: '32px',
                  height: '32px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexShrink: 0,
                  borderRadius: '10px',
                  border: '1px solid rgba(59, 130, 246, 0.22)',
                  background: 'rgba(59, 130, 246, 0.14)',
                }}
              >
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    flexShrink: 0,
                    borderRadius: '5px',
                    background: 'rgba(59, 130, 246, 0.50)',
                  }}
                />
              </div>

              {/* Content bars */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  flex: '1',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    width: '95.19px',
                    height: '5px',
                    borderRadius: '2.5px',
                    background: 'rgba(255, 255, 255, 0.09)',
                  }}
                />
                <div
                  style={{
                    width: '67.19px',
                    height: '5px',
                    borderRadius: '2.5px',
                    background: 'rgba(255, 255, 255, 0.09)',
                  }}
                />
              </div>

              {/* Toggle button */}
              <div
                style={{
                  display: 'flex',
                  width: '44px',
                  height: '22px',
                  padding: '3px',
                  alignItems: 'center',
                  borderRadius: '11px',
                  background: 'rgba(59, 130, 246, 0.25)',
                  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.40) inset',
                }}
              >
                <div
                  style={{
                    width: '16px',
                    height: '16px',
                    borderRadius: '8px',
                    background:
                      'linear-gradient(135deg, rgba(59, 130, 246, 0.80) 0%, rgba(139, 92, 246, 0.80) 100%)',
                    boxShadow: '0 1px 0 0 rgba(255, 255, 255, 0.30) inset',
                    marginLeft: '22px',
                  }}
                />
              </div>
            </div>

            {/* Second card */}
            <div
              style={{
                display: 'flex',
                padding: '12px',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.04)',
                background: 'rgba(255, 255, 255, 0.02)',
                boxShadow:
                  '0 4px 12px 0 rgba(0, 0, 0, 0.25), 0 1px 0 1px rgba(255, 255, 255, 0.04) inset',
              }}
            >
              {/* Blue icon on the left */}
              <div
                style={{
                  display: 'flex',
                  width: '32px',
                  height: '32px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexShrink: 0,
                  borderRadius: '10px',
                  border: '1px solid rgba(59, 130, 246, 0.22)',
                  background: 'rgba(59, 130, 246, 0.14)',
                }}
              >
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    flexShrink: 0,
                    borderRadius: '5px',
                    background: 'rgba(59, 130, 246, 0.50)',
                  }}
                />
              </div>

              {/* Content bars */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  flex: '1',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    width: '95.19px',
                    height: '5px',
                    borderRadius: '2.5px',
                    background: 'rgba(255, 255, 255, 0.09)',
                  }}
                />
                <div
                  style={{
                    width: '67.19px',
                    height: '5px',
                    borderRadius: '2.5px',
                    background: 'rgba(255, 255, 255, 0.09)',
                  }}
                />
              </div>

              {/* Status dot (green) */}
              <div
                style={{
                  width: '10px',
                  height: '10px',
                  flexShrink: 0,
                  borderRadius: '5px',
                  background: 'rgba(34, 197, 94, 0.70)',
                  boxShadow:
                    '0 0 12px 0 rgba(34, 197, 94, 0.60), 0 0 20px 0 rgba(34, 197, 94, 0.30)',
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
